import React, { useState } from 'react';
import Layout from "../../../layout/layout";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { TextField, Button, Box, Typography, Divider, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar, Alert } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import axios from "../../../api/axios";
import { format } from 'date-fns';
import dayjs from 'dayjs';



const MenuPage = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedDate2, setSelectedDate2] = useState(new Date());
    const [selectedDate3, setSelectedDate3] = useState(new Date());
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [date, setDate] = useState(dayjs());
    const [sourceStartDate, setSourceStartDate] = useState(dayjs());
    const [sourceEndDate, setSourceEndDate] = useState(dayjs());
    const [destStartDate, setDestStartDate] = useState(dayjs());
    const [destEndDate, setDestEndDate] = useState(dayjs());
    const [rangeLoading, setRangeLoading] = useState(false);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleDateChange2 = (date) => {
        setSelectedDate2(date);
    };

    const handleDateChange3 = (date) => {
        setSelectedDate3(date);
    };

    const disableNonSaturdays = (date) => {
        return date.getDay() !== 6;
    };

    const handleSubmit = () => {
        const service_date = format(selectedDate, "yyyy-MM-dd");
        const new_date = format(selectedDate2, "yyyy-MM-dd");

        const data = {
            service_date,
            new_date
        };
        try {
            axios.post("menu/copy-service-date/", data)
                .then(response => {
                    if (response.status === 200) {
                        alert('Success!');
                    } else {
                        alert('Error!');
                    }
                })
                .catch(error => {
                    console.log(error);
                    alert('Error!');
                });
        }
        catch (error) {
            console.log(error);
            alert('Error!');
        }

    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            const response = await axios.post("menu/delete/", {
                service_date: dayjs(date).format('YYYY-MM-DD')
            });

            if (response.status === 200) {
                setAlertMessage("Menu deleted successfully");
                setAlertSeverity("success");
                setAlertOpen(true);
                setOpen(false);
            }
        } catch (error) {
            console.error(error);
            setAlertMessage(error.response?.data?.error || "Failed to delete menu");
            setAlertSeverity("error");
            setAlertOpen(true);
        } finally {
            setLoading(false);
        }
    };

    const handleAlertClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setAlertOpen(false);
    };

    const isInSourceRange = (date) => {
        const d = dayjs(date).startOf('day');
        const start = dayjs(sourceStartDate).startOf('day');
        const end = dayjs(sourceEndDate).startOf('day');
        if (!d.isValid() || !start.isValid() || !end.isValid()) return false;
        return !d.isBefore(start) && !d.isAfter(end);
    };

    const sourceDiff = dayjs(sourceStartDate).isValid() && dayjs(sourceEndDate).isValid()
        ? dayjs(sourceEndDate).startOf('day').diff(dayjs(sourceStartDate).startOf('day'), 'day')
        : null;
    const destDiff = dayjs(destStartDate).isValid() && dayjs(destEndDate).isValid()
        ? dayjs(destEndDate).startOf('day').diff(dayjs(destStartDate).startOf('day'), 'day')
        : null;

    let rangeError = "";
    if (!dayjs(sourceStartDate).isValid() || !dayjs(sourceEndDate).isValid() ||
        !dayjs(destStartDate).isValid() || !dayjs(destEndDate).isValid()) {
        rangeError = "All four dates are required.";
    } else if (sourceDiff < 0) {
        rangeError = "Source end date must not be before source start date.";
    } else if (destDiff < 0) {
        rangeError = "Destination end date must not be before destination start date.";
    } else if (
        !dayjs(destStartDate).startOf('day').isAfter(dayjs(sourceEndDate).startOf('day')) &&
        !dayjs(destEndDate).startOf('day').isBefore(dayjs(sourceStartDate).startOf('day'))
    ) {
        rangeError = "Destination range cannot overlap the source range.";
    } else if (sourceDiff !== destDiff) {
        rangeError = `Source range has ${sourceDiff + 1} day${sourceDiff === 0 ? '' : 's'} but destination has ${destDiff + 1}.`;
    }

    const handleRangeSubmit = async () => {
        try {
            setRangeLoading(true);
            const response = await axios.post("menu/copy-service-date-range/", {
                source_start_date: dayjs(sourceStartDate).format('YYYY-MM-DD'),
                source_end_date: dayjs(sourceEndDate).format('YYYY-MM-DD'),
                new_start_date: dayjs(destStartDate).format('YYYY-MM-DD'),
                new_end_date: dayjs(destEndDate).format('YYYY-MM-DD'),
            });
            if (response.status === 200) {
                setAlertMessage(`Menu range copied successfully (${response.data.days_copied} days).`);
                setAlertSeverity("success");
                setAlertOpen(true);
            }
        } catch (error) {
            console.error(error);
            setAlertMessage(error.response?.data?.error || "Failed to copy menu range.");
            setAlertSeverity("error");
            setAlertOpen(true);
        } finally {
            setRangeLoading(false);
        }
    };

    const body = (
        <div>
            {/* TODO(deprecate): remove after range-copy is verified. */}
        <Typography variant="h6" marginBottom={2}>Copy menu</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>

                <Box display="flex" gap={2} alignItems="center">
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        label="Original Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                        renderInput={(props) => <TextField {...props} fullWidth />}
                    />
                    <ArrowRightAltIcon />
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        label="Copy to"
                        value={selectedDate2}
                        onChange={handleDateChange2}
                        renderInput={(props) => <TextField {...props} fullWidth />}
                    />
                    <Button variant="contained" color="primary" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Box>
            </LocalizationProvider>

            <Divider sx={{ my: 3 }} />

            {/* New: date-range copy. The single-date copy above is slated for removal once this is verified. */}
            <Typography variant="h6" marginBottom={2}>Copy menu (date range)</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        label="Source Start"
                        value={sourceStartDate}
                        onChange={(date) => setSourceStartDate(date)}
                        renderInput={(props) => <TextField {...props} />}
                    />
                    <ArrowRightAltIcon />
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        label="Source End"
                        value={sourceEndDate}
                        onChange={(date) => setSourceEndDate(date)}
                        renderInput={(props) => <TextField {...props} />}
                    />
                </Box>
                <Box display="flex" flexWrap="wrap" gap={2} alignItems="center" mt={1}>
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        label="Destination Start"
                        value={destStartDate}
                        onChange={(date) => setDestStartDate(date)}
                        shouldDisableDate={isInSourceRange}
                        renderInput={(props) => <TextField {...props} />}
                    />
                    <ArrowRightAltIcon />
                    <DatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        label="Destination End"
                        value={destEndDate}
                        onChange={(date) => setDestEndDate(date)}
                        shouldDisableDate={isInSourceRange}
                        renderInput={(props) => <TextField {...props} />}
                    />
                </Box>
            </LocalizationProvider>
            {rangeError && (
                <Typography color="error" variant="caption" display="block" mt={1}>
                    {rangeError}
                </Typography>
            )}
            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={handleRangeSubmit}
                disabled={!!rangeError || rangeLoading}
            >
                {rangeLoading ? "Copying..." : "Copy Range"}
            </Button>

            <Divider sx={{ my: 3 }} />

            <Snackbar
                open={alertOpen}
                autoHideDuration={6000}
                onClose={handleAlertClose}
            >
                <Alert
                    onClose={handleAlertClose}
                    severity={alertSeverity}
                    sx={{ width: "100%" }}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/YYYY"
                    label="Select Date to Delete"
                    value={date}
                    onChange={(date) => setDate(date)}
                    fullWidth
                    renderInput={(props) => <TextField sx={{ mt: 2, width: 220 }} {...props} />}
                />
            </LocalizationProvider>

            <Button
                variant="contained"
                color="error"
                sx={{ mt: 2, ml: 2 }}
                onClick={handleClickOpen}
            >
                Delete Menu
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Delete Menu Confirmation"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you want to delete the menu for {dayjs(date).format('DD/MM/YYYY')}?
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDelete}
                        autoFocus
                        color="error"
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

    return <Layout body={body} title={"Menu"} />;
};

export default MenuPage;